<template>
  <div id="expenses" class="wrrapper">
    <page-heading title="Expenses">
      <template #content>
        <div class="expenses flex align-center">
          <Button
            title="Add expenses"
            className="button--primary mr-2"
            :onClick="handleAddExpenses"
          />
          <Select
            v-if="isAdmin"
            class="ml-2"
            styles="expenses-select"
            :input="handleBranchChange"
            :options="brachData"
            :placeholder="
              brachData.length
                ? brachData && brachData.find(item => item.key == 1).name
                : ''
            "
          />
          <!-- // brnach for user needs to integrated, only admin side is handled -->
        </div>
      </template>
    </page-heading>
    <div class="content">
      <data-table
        :cols="columns"
        :rows="listExpense"
        height="calc(100vh - 14.5rem)"
        :loading="loading"
        :pagination="listExpense.length > 0"
        :totalPages="pagination.total_pages"
        :resultCount="pagination.total"
        :itemsPerPage="pagination.page_size"
        :currentPage="pagination.page_no"
        :onPageChanged="pageChanged"
      >
        <template slot="action" slot-scope="{ actions }">
          <dropdown-menu
            :rowData="actions"
            :handleItemClick="handleItems"
            :items="items"
          />
        </template>
      </data-table>
    </div>
    <modal
      title="Add Expense"
      name="expenseModal"
      class="custom-modal"
      height="auto"
      width="50%"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="mt-3">
          <form @submit.prevent class="create-service mb-base">
            <div class="flex space-between">
              <Select
                class="mb-base type-select"
                label="Expense Type"
                :value="expenses.name"
                :input="handleExpenseType"
                :options="types"
                :clearable="false"
              />
              <Select
                class="mb-base type-select"
                label="Type"
                :input="handleCreditDebit"
                :value="expenses.type"
                :options="['Credit', 'Debit']"
                :clearable="false"
              />
            </div>
            <div
              class="new-expense flex align-center mb-base cursor"
              @click="newExpense"
            >
              <img src="@/assets/plus-icon-small.png" alt="icon" />
              <span>Add new Expense type </span>
            </div>
            <Input
              v-if="newExpenseType"
              class="mb-base expense-input"
              type="text"
              v-model="expenses.name"
            />

            <div class="flex">
              <Input
                class="mb-base expense-input"
                label="Amount"
                type="number"
                v-model="expenses.amount"
              />
              <Select
                v-if="isAdmin"
                class="mb-base ml-2 type-select"
                label="Select Branch"
                :placeholder="userBranchName"
                :options="brachData"
                :input="handleSelectBranch"
                :clearable="false"
                required
              />
            </div>
            <TextArea
              styles="narration mb-base"
              label="Narration"
              rows="3"
              name="narration"
              v-model="expenses.narration"
            />
            <Button
              className="button--primary"
              title="Add Expense"
              :onClick="addCharges"
            ></Button>
          </form>
        </div>
      </template>
    </modal>
    <Edit :actions="actions" :types="types" :currentData="currentData" />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Button from "@/components/Button";
import Select from "@/components/Select";
import DropdownMenu from "@/components/DropdownMenu";
import Modal from "@/components/Modal";
import Input from "@/components/Input";
import TextArea from "@/components/TextArea";
import Edit from "./edit";
import { mapActions, mapGetters } from "vuex";
import { formatExpenseType } from "@/utils/helpers";
import { formatCreditDebit, formatedDate } from "../../../utils/helpers";

import moment from "moment";
export default {
  components: {
    DropdownMenu,
    DataTable,
    TextArea,
    Button,
    Select,
    Modal,
    Input,
    Edit
  },
  data() {
    return {
      test: "12312",
      expenses: {},
      actions: {},
      newExpenseType: false,
      items: ["Edit", "Delete"],
      sortOptions: [
        { name: "Last 1 day", key: 1 },
        { name: "Last 3 days", key: 3 },
        { name: "Last 7 days", key: 7 }
      ],
      columns: [
        { column: "serial", label: "#", width: "60" },
        {
          column: "name",
          label: "Expense Type",
          sortable: true,
          link: true,
          routerName: "ExpensesDetails"
        },
        {
          column: "created_at",
          label: "Created At",
          sortable: true,
          sort: true
        },
        { column: "createdBy", label: "Created By", sortable: true },
        { column: "action", label: "Actions" }
      ],
      brachData: [],
      checkValue: "",
      isAdmin: false,
      dateValue: "",
      placeholder: true,
      currnetDate: "",
      selectedBranch: null,
      branchIdForAddExpense: null,
      currentData: {},
      filters: {
        start_date: formatedDate(),
        end_date: formatedDate()
      }
    };
  },

  computed: {
    ...mapGetters({
      expenseType: "expenses/expenseType",
      detailExpenses: "expenses/detailExpenses",
      pagination: "expenses/pagination",
      user: "auth/userInfo",
      loading: "loading",
      fetchUserBranch: "expenses/fetchUserBranch"
    }),
    types() {
      return (
        this.expenseType &&
        this.expenseType.map(item => ({
          id: item.id,
          name: item.name
        }))
      );
    },
    userBranchName() {
      const name = this.brachData.find(
        item => item.key == this.branchIdForAddExpense
      )?.name;
      return name;
    },
    listExpense() {
      return (
        this.expenseType &&
        this.expenseType.map(item => ({
          ...item,
          createdBy: item && item.updatedBy && item.updatedBy.employ.full_name
        }))
      );
    }
  },
  created() {
    this.isAdmin = this.user.userRole.some(({ name }) => name === "admin");
  },
  methods: {
    ...mapActions("expenses", [
      "addExpenses",
      "expenseTypeList",
      "sortExpanses",
      "deleteExpense",
      "fetchBranch",
      "fetchBrachDetails",
      "expensesDetails"
    ]),
    newExpense() {
      this.newExpenseType = !this.newExpenseType;
    },
    handleCreditDebit(val) {
      this.expenses.type = val;
    },
    handleDate(e) {
      if (e) {
        this.placeholder = false;
        const selectedDate = moment(e).format("YYYY-MM-DD");
        const params = {
          date: JSON.stringify(selectedDate),
          branchId: this.selectedBranch
        };
        this.sortExpanses(params);
        this.currnetDate = selectedDate;
      }
    },
    handleAddExpenses() {
      this.$modal.show("expenseModal");
    },
    addCharges() {
      this.expenses.type = formatExpenseType(this.expenses.type);
      if (this.branchIdForAddExpense !== null) {
        this.expenses.userId = this.user.id;
        this.expenses.branchId = this.branchIdForAddExpense;
        this.addExpenses(this.expenses).then(() => {
          this.$toasted.success("Expense added successfully").goAway("3000");
          this.$modal.hide("expenseModal");
          this.expenses = {};
          this.newExpenseType = false;
          this.branchIdForAddExpense = null;
        });
      } else {
        this.$toasted.error("Please fill all input field").goAway("3000");
      }
    },
    calculateValue(pageNum) {
      if (pageNum <= 0) {
        return null;
      }
      return (pageNum - 1) * 20;
    },
    handleBranchChange(val) {
      if (val && val != null) {
        const currentPage = this.pagination.page_no;
        const skip = this.calculateValue(currentPage);
        this.selectedBranch = val;
        const data = {
          date: JSON.stringify(this.currnetDate),
          branch: val,
          pageNumber: currentPage,
          take: 20,
          skip: skip
        };
        this.fetchBrachDetails(data);
      }
      if (val === null) {
        this.expenseTypeList();
      }
    },
    handleExpenseType(val) {
      this.expenses.expenseTypeId = val.id;
    },
    pageChanged(val) {
      this.expenseTypeList(val);
    },
    async handleItems(val, actions) {
      this.filters.branchId = 1;
      await this.expensesDetails({ id: actions.id, payload: this.filters });

      const [expense] = this.detailExpenses;
      this.currentData.type = formatCreditDebit(expense?.type);
      this.currentData.amount = expense?.amount;
      this.currentData.narration = expense?.narration;
      this.currentData.selectedBranch = this.brachData.find(
        item => item.key == expense?.branchId
      )?.name;

      val === "Edit"
        ? ((this.actions = actions), this.$modal.show("updateExpenses"))
        : val === "Delete" &&
          this.deleteExpense(actions.id).then(() => {
            this.$toasted
              .success("Expense deleted successfully")
              .goAway("3000");
          });
    },
    handleSelectBranch(val) {
      this.branchIdForAddExpense = val.key;
    }
  },
  async mounted() {
    this.expenseTypeList();
    const date = moment()
      .subtract("d")
      .format("YYYY-MM-DD");
    this.currnetDate = date;
    this.selectedBranch = this.user.userBranchId;
    await this.fetchBranch();
    this.fetchUserBranch.map(elem => {
      this.value = elem.name;
      this.brachData.push({ name: elem.name, key: elem.id });
    });
    this.branchIdForAddExpense = this.user.userBranchId;
  }
};
</script>

<style>
#expenses .footer {
  margin-right: 30px;
}

.type-select {
  flex: 0 0 48%;
  max-width: 48%;
}

.expense-input {
  width: 48%;
}

.narration {
  width: 48% !important;
}

.new-expense span {
  margin-left: 8px;
  font-size: var(--fs-xs);
  line-height: 16px;
  letter-spacing: var(--tracking-eyebrow);
  color: var(--accent-600);
}
.date-filter .custom-datepicker {
  margin-top: 0;
}
.date_picker {
  position: relative;
}
.date_picker_placeholder {
  position: absolute;
  z-index: 99;
  top: 10px;
  left: 10px;
  font-weight: 600;
}
</style>
